module.exports = __webpack_public_path__ + "img/SpotifyPlaylist.a94ff4d0.jpg";